import { render } from "./indexStepComponent.vue?vue&type=template&id=2abfd8a8"
import script from "./indexStepComponent.vue?vue&type=script&lang=js"
export * from "./indexStepComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__